// ABO-KNOPF-03, Betreiberfreigabe 30.10.2026: einzige Stelle der Sichtbarkeitsregel „Abo abschließen“
// (Knopf in der Tarifkarte, Hinweis oben auf der Einstellungsseite). Rein: kein Netz, kein Fenster,
// kein Speicher; Zeit nur über `jetzt` (Millisekunden). Eingaben aus public_access_state und Firmendokument.
export function aboAbschlussAnzeige({ access_state, account_status, trial_ends_at } = {}, jetzt) {
  const access = access_state || {};
  const knopf = !(
    access.license_status === "aktiv_durch_zahlung" ||
    !!access.payment_pending ||
    access.reason === "read_only_license_inaktiv" ||
    access.reason === "read_only_suspended" ||
    access.reason === "read_only_license_invalid"
  );
  let hinweis = null;
  if (access_state && knopf) {
    if (access.read_only && access.reason === "read_only_vertragsende") {
      hinweis = "vertragsende";
    } else if (access.read_only && access.reason === "read_only_expired") {
      hinweis = "test_abgelaufen";
    } else if (
      !access.read_only &&
      !access.license_status &&
      account_status === "demo" &&
      trial_ends_at &&
      new Date(trial_ends_at).getTime() >= jetzt
    ) {
      hinweis = "testphase";
    }
  }
  return { knopf, hinweis };
}
